module.exports = __webpack_public_path__ + "static/img/li.c2a0388c.svg";